module.exports = __webpack_public_path__ + "media/images/shared/icon_todo_white-06336bb6792213bf91b43a0f37c00647.png";